

import React, {forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet } from "react-helmet";
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import ApplicationLayout from '../../layouts/ApplicationLayout';
import TapIcon from '../../services/TapIcon';
import {ORG_AUTH_URL, ORG_LOG_URL } from '../../services/TapApiUrls';
import HttpAPICall from '../../services/HttpAPICall';
import Loader from '../../components/ui/Loader/Loader';
import TapHelper from '../../services/TapHelper';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../components/TapUi';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Status from '../../components/ui/Status';
import DateService from '../../services/DateService';
import moment from 'moment';
import InputUserSearch from '../includes/ui/InputUserSearch';

const EmailLogList                  =   forwardRef((props, ref) => {

    let initListData                        =   {
        loading                                 :   false,
        items                                   :   [],
        meta                                    :   null,
        page                                    :   1,
        detail_loading                          :   false,
        details                                 :   {}
    };
 
    let initFormData                        =   {
        per_page                                :   50,
        date_range                              :   null,
        date_range_start                        :   null,
        date_range_end                          :   null,
        search_email_id                         :   '',
        search_subject                          :   '',
        search_user_ids                          :   []

    };
    let formDataLabel                       =   {
        date_range                              :   'Date Range : ',
        search_email_id                         :   'Email : ',
        search_subject                          :   'Subject : ',
        search_user_ids                         :   'Users : ',

    };
    let itemListUrl                         =   ORG_LOG_URL + "/emails/list";
    let itemDetailUrl                       =   ORG_LOG_URL + "/emails/detail";


    
    const access_token                                  =   useSelector(state => state.auth.access_token);
    const all_periods                                   =   useSelector(state => state.app.all_periods ? state.app.all_periods : []);
    const emailModalElem                                =   useRef(null);
    const emailModal                                    =   useRef(null);
    const emailModalOpen                                =   ()  => emailModal.current && emailModal.current.show()
    const emailModalClose                               =   ()  => emailModal.current && emailModal.current.hide()
    const searchModalElem                               =   useRef(null);
    const searchModal                                   =   useRef(null);
    const criteriaRef                                   =   useRef()
    const searchModalOpen                               =   ()  => searchModal.current && searchModal.current.show()
    const searchModalClose                              =   ()  => searchModal.current && searchModal.current.hide()
    const [searchModalId, setSearchModalId]             =   useState(uuid());
    const [criteriaHeight ,setCriteriaHeight]           =   useState(0)   
    const [itemsData, setItemsData]                     =   useState({...initListData});
    const [formData, setFormData]                       =   useState({...initFormData});
    const [searchedElems, setSearchedElems]             =   useState([]);
    const [submittedFormData, setSubmittedFormData]     =   useState({...initFormData});
    const [emailModalId, setEmailModalId]               =   useState(uuid());
    const [periods, setPeriods]                         =   useState('');
    const [searchedUsers, setSearchedUsers]             =   useState([]);


         

     const updateCriteriaHeight = () => {
        if (criteriaRef.current) {            
            const height = criteriaRef.current.offsetHeight;

                if (criteriaHeight !== height) {
                    setCriteriaHeight(height)
             }
            }
        };
    useEffect(() => {
        searchModalElem.current = document.getElementById(searchModalId);
        searchModal.current = new Modal(searchModalElem.current, { keyboard: false, backdrop: false });
        emailModalElem.current = document.getElementById(emailModalId);
        emailModal.current = new Modal(emailModalElem.current, { keyboard: false, backdrop: false });
        loadItemsData(1);
        let periods_data = [...all_periods, { key: 'custom', display: 'Custom Date Range' }];
        setPeriods(periods_data)
        return () => {
            if (searchModal.current) {
                searchModal.current.dispose();
            }
             if (emailModal.current) {
                emailModal.current.dispose();
            }
        };
    }, []);
    useEffect(() => {
        const handleResize = () => {
            updateCriteriaHeight();
        };
        const resizeObserver = new ResizeObserver(handleResize);
        if (criteriaRef.current) {
            resizeObserver.observe(criteriaRef.current);
        }
        updateCriteriaHeight();
        return () => {
            resizeObserver.disconnect();
        };
    }, [searchedElems]);

    const loadItemsData = (page = 1, customFormData = null) => {
        setItemsData(pd => ({ ...pd, loading: true, page: page }));
        const dataToUse = customFormData || formData;

        let params = {
            page: page,
            ...dataToUse
        };

        HttpAPICall.withAthorization('GET', itemListUrl, access_token, params, {}, (response) => {
            let respData = response.data;
            let meta = TapHelper.pick(respData, ['from', 'to', 'total', 'last_page', 'per_page', 'current_page']);
            setItemsData(pd => ({ ...pd, items: respData.data, meta: meta }));
        }).then(() => {
            setItemsData(pd => ({ ...pd, loading: false }));
        });
    }
    const loadDetailData = (id) => {
        setItemsData(pd => ({ ...pd, detail_loading: true}));
        HttpAPICall.withAthorization('GET', `${itemDetailUrl}/${id}`, access_token, {}, {}, (response) => {
            let respData = response.data;
            setItemsData(pd => ({ ...pd, details: respData}));
        }).then(() => {
            setItemsData(pd => ({ ...pd, detail_loading: false }));
        });
    }
    const tapSelectChange = (selectedOption, formName, fieldName) => {
        const value = Array.isArray(selectedOption) ?
            selectedOption.map(option => option.value) :
            (selectedOption ? selectedOption.value : '');

        setFormData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };

    const listSearchModalInit = () => {
        searchModalOpen();
    }
    const listemailModalInit = (id) => {
        emailModalOpen();
        loadDetailData(id)
    }
    const submitSearchFormHandler = (e) => {
        e.preventDefault();
        let searchedElems = [];
        let searchParams = {};
        Object.keys(formData).map((key) => {
            let label = formDataLabel[key];
            let value = formData[key];
            if (value && value !== "Invalid date" && value.length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;
                    if (key == 'search_subject') {
                        show_val = formData && formData.search_subject ? formData.search_subject : '';
                    }
                    if (key == 'search_email_id') {
                        show_val = formData && formData.search_email_id ? formData.search_email_id : '';
                    }
                    if(key == 'search_user_ids') {
                        show_val            =   searchedUsers ? searchedUsers.map(s => s.label).join(', ') : '';
                    }
                    if (key == 'date_range') {
                        let start_range = moment(formData.date_range_start).format('DD-MMM-YYYY');
                        let end_range = moment(formData.date_range_end).format('DD-MMM-YYYY')
                        let display_custom = `Custom Date Range (${start_range} - ${end_range})`
                        show_val = periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        setSubmittedFormData({ ...formData });
        setSearchedElems(searchedElems);
        searchModalClose();
        loadItemsData(1);
    }
    const searchFormClear = () => {
        const resetFormData = { ...initFormData };
        setFormData(resetFormData);
        setSubmittedFormData(resetFormData);
        setSearchedElems([]);
        setSearchedUsers([]);
        loadItemsData(1, resetFormData);
        setCriteriaHeight(0);
    }
  
    const searchModalJsx = () => {
        return <><div className="modal fade" id={searchModalId} tabIndex="-1" ref={searchModalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Email Logs Search</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" 
                            onClick={() => {
                                setFormData({ ...submittedFormData })
                            }} disabled={itemsData.loading} aria-label="Close"></button>
                    </div>
                    <div className="modal-body"> <form name='' id={searchModalId + 'Form'} onSubmit={submitSearchFormHandler}>
                        <div className="row my-3 align-items-center">
                            <label className="col-sm-3 col-form-label col-form-label-sm">Send To</label>
                            <div className="col-sm-9">
                                <input
                                    type="email"
                                    value={formData.search_email_id}
                                    className="form-control"
                                    autoComplete="off"
                                    onChange={e => setFormData(d => ({ ...d, search_email_id: e.target.value }))}
                                    placeholder="Search by Email"
                                    style={{ height: "30px", fontSize: "93%" }}
                                />
                            </div>
                        </div>
                         <div className="row my-3 align-items-center">
                            <label className="col-sm-3 col-form-label col-form-label-sm">Subject</label>
                            <div className="col-sm-9">
                                <input
                                    type="text"
                                    value={formData.search_subject}
                                    className="form-control"
                                    autoComplete="off"
                                    onChange={e => setFormData(d => ({ ...d, search_subject: e.target.value }))}
                                    placeholder="Search by Subject"
                                    style={{ height: "30px", fontSize: "93%" }}
                                />
                            </div>
                        </div>
                        <div className="row my-3 align-items-center">
                            <label className="col-sm-3 col-form-label col-form-label-sm">Send From</label>
                            <div className="col-sm-9">
                                <InputUserSearch
                                     changeEvent={(selectedOption) => {
                                        tapSelectChange(selectedOption, 'formData', 'search_user_ids');
                                        setSearchedUsers(selectedOption && selectedOption.length > 0 ? selectedOption : [])
                                    }}
                                    isMulti={true}
                                    containerHeight="30px"
                                    fontSize="93%"
                                    value={searchedUsers.length > 0 ? searchedUsers.map(a => { a.label = a.label; return a; }) : []}
                                    placeholder="Search Send From User by Name, Email & Mobile Number"
                                />
                            </div>
                        </div>
                        <div className="row my-3 align-items-center">
                            <label className="col-sm-3 col-form-label col-form-label-sm ">Transaction Period</label>
                            <div className="col-sm-9">
                                <PeriodSelectionWithCustom
                                    periods={periods ? periods : []}
                                    className="form-control-sm"
                                    containerHeight="33px"
                                    fontSize="93%"
                                    menuPlacement={"bottom"}
                                    onSelectPeriod={(period, startDate, endDate) => {
                                        setFormData(d => ({
                                            ...d,
                                            date_range: period,
                                            date_range_start: startDate ? startDate : null,
                                            date_range_end: endDate ? endDate : null
                                        }))
                                    }}
                                    value={formData.date_range}
                                    startDate={formData.date_range_start}
                                    endDate={formData.date_range_end}
                                />
                            </div>
                        </div>

                    </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={() => setFormData({...submittedFormData})} data-bs-dismiss="modal">Close</button>
                        <button form={searchModalId + 'Form'} type="submit" className="btn btn-primary">Submit</button>
                    </div>
                </div>
            </div>
        </div>
        </>
    }

    const emailModalJsx = () => {
        return <div className="modal fade" id={emailModalId} tabIndex="-1" ref={emailModalElem}>
            <div className="modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Subject : {itemsData?.details?.subject}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body p0">
                        {itemsData?.detail_loading ? <Loader /> : itemsData?.details?.body ? <div dangerouslySetInnerHTML={{ __html: itemsData?.details?.body }}></div> : <p>No Content</p>}
                    </div>
                </div>
            </div>
        </div>
    }

    const voucherListJsx = () => {
        return <>
            <div ref={criteriaRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    background: 'white',
                }}>
                <DisplaySearchCriteria searchedElems={searchedElems} onClearFilter={searchFormClear} />
            </div>
            <table className="table table-sm table-bordered align-middle bg-white">
                <thead className="align-middle table-secondary" style={{
                    top: `${criteriaHeight}px`,
                    position: 'sticky',
                }}>
                    <tr className='text-center'>
                        <th style={{ width: "3%" }}>#</th>
                        <th style={{ width: "12%" }}>Subject</th>
                        <th style={{ width: "10%" }}>Email Type</th>
                        <th style={{ width: "15%" }}>To Email</th>
                        <th style={{ width: "15%" }}>CC Email</th>
                        <th style={{ width: "14%" }}>Send From</th>
                        <th style={{ width: "12%" }}>Time</th>
                    </tr>
                </thead>
                <tbody>
                    {itemsData.loading
                        ? <tr><td className='text-center' colSpan={9}><Loader /></td></tr>
                        : ((itemsData.items && itemsData.items.length > 0)
                            ? itemsData.items.map((item, index) => {
                                return (
                                    <tr key={item.id} className='text-center text-sm'>
                                        <td >{index + 1}</td>
                                          <td><Link onClick={() => { listemailModalInit(item.id) }}>{item?.subject || "-"}</Link></td>
                                        <td>{item?.mail_type || "-"}</td>
                                        <td className='text-start'>
                                            {item.to_emails.map((email, idx) => (
                                                <div key={idx}>
                                                    {email[0]} {email[1] && <span>({email[1]})</span>}
                                                </div>
                                            ))}
                                        </td>
                                        <td className='text-start'>
                                            {item.cc_emails.map((email, idx) => (
                                                <div key={idx}>
                                                    {email[0]} {email[1] && <span>({email[1]})</span>}
                                                </div>
                                            ))}
                                        </td>
                                        <td>
                                            {item?.sender?.full_name || "-"}
                                            
                                        </td>
                                        <td>{DateService.dateFormat(item.created_at, 'DD-MMM-YYYY HH:mm:ss')}</td>
                                    </tr>
                                );
                            })
                            : <tr><td className='text-center' colSpan={9}>No Record</td></tr>)
                    }
                </tbody>
            </table>

            <DisplayListPagination meta={itemsData.meta} onPageChange={(e) => loadItemsData(e.selected + 1)} />
        </>
    }

    const topRightHeaderJsx = () => {
        return <>
            <button type="button" className="btn btn-secondary" disabled={itemsData.loading} onClick={listSearchModalInit} >
                <TapIcon.imageIcon icon={TapIcon.SearchIcon} />
            </button>
        </>
    }

    const pageHeading = () => {
        return (<>
            <Helmet><title>Email Logs</title></Helmet>
            <div className="page_title m0 row align-middle">
                <div className='col-sm-12'>
                    <div className='d-flex align-items-center justify-content-between'>
                        <h3 className='mb-0'>Email Logs</h3>
                         <div className='text-end  mt15'>
                            {topRightHeaderJsx()}
                        </div> 
                    </div>
                </div>
            </div>
        </>)
    }

    return <ApplicationLayout>
        {pageHeading()}
        <div className="container-fluid pl5">
            <div className='page_containt row'>
                <div className='pageTbl col-sm-12' >{voucherListJsx()}</div>
            </div>
        </div>
        {searchModalJsx()}
        {emailModalJsx()}
    </ApplicationLayout>

});

export default EmailLogList;